import { Col, Form, Row } from 'antd';
import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { AdminSettingsRequest } from '../../../../request/AuthRequest';

const FormComponent = observer((props) => {
	const { handleChange, onFinish, id, form } = props;
	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
		>
			<Row gutter={24}>
				<Col span={12}>
					<InputComponent
						required
						name="settingKey"
						label="Setting Key"
						placeholder="Enter Setting Key"
						onChange={handleChange}
						rules={AdminSettingsRequest.settingKey}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="settingName"
						label="Setting Name"
						placeholder="Enter Setting Name"
						onChange={handleChange}
						rules={AdminSettingsRequest.settingName}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="settingValue"
						label="Setting Value"
						placeholder="Enter Setting Value"
						onChange={handleChange}
						rules={AdminSettingsRequest.settingValue}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="settingdbType"
						label="Setting DB Type"
						placeholder="Enter Setting DB Type"
						onChange={handleChange}
						rules={AdminSettingsRequest.settingdbType}
					/>
				</Col>
			</Row>
		</Form>
	);
});
export default FormComponent;
